import React from 'react';
import TaisaCoreLogo from './TaisaCoreLogo';
import './LoadingScreen.css';

/**
 * Full-screen loading component with TaisaCore branding
 * Used for app initialization, route transitions, etc.
 */
const LoadingScreen = ({ message = 'טוען...' }) => {
  return (
    <div className="loading-screen">
      <TaisaCoreLogo size="xlarge" animated={true} withBackground={false} />
      <p className="loading-message">{message}</p>
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingScreen;
